/*
PW Simple Button
Useful for avoiding _.partial or .bind click handlers for passing onClick argumnets,
in a similar fashion to the PW MenuItem component
*/

import _ from 'lodash'
import React from 'react'
import T from 'prop-types'

const _propTypes = {
  args: T.array,
  children: T.node,
  className: T.string,
  el: T.string, // Element name (span, div, etc)
  onClick: T.func.isRequired,
  passEventAsFirstArg: T.bool, // If true, the click handler will be called with the event as the first argument
  stopPropagation: T.bool,
  disabled: T.bool,
  type: T.oneOf(['button', 'submit', 'reset']) // Only used when `el`='button'
}

export default class SimpleButton extends React.Component {
  static displayName = 'Button'

  static propTypes = _propTypes

  static defaultProps = {
    className: 'btn btn-default',
    el: 'span',
    passEventAsFirstArg: false,
    type: 'button'
  }

  handleClick = (e) => {
    const {
      args = [],
      onClick,
      passEventAsFirstArg,
      stopPropagation
    } = this.props
    if (stopPropagation) {
      e.stopPropagation()
    }
    if (passEventAsFirstArg) {
      args.unshift(e)
    }
    onClick(...args)
  }

  _onKeyDown = e => {
    if (e.key === 'Enter') {
      this.handleClick(e)
      e.preventDefault()
    }
  }

  render() {
    const {
      className,
      el,
      children,
      disabled,
      type
    } = this.props
    const Elem = el

    const elemProps = _.omit(this.props, _.keys(_propTypes))
    if (el === 'button') {
      elemProps.type = type
      elemProps.disabled = disabled
    }
    return (
      <Elem
        {...elemProps}
        className={className}
        onClick={disabled ? null : this.handleClick}
        onKeyDown={disabled ? null : this._onKeyDown}
        role="button"
        tabIndex={disabled ? null : 0}
      >{children}</Elem>
    )
  }
}
